export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.14.0',
};
//# sourceMappingURL=buildEnv.js.map